import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.loginName = '' // 场馆账号
      this.venueName = '' // 场馆名称
    }
  }
}
export default searchFrom
